import * as React from 'react';

import {HelpButton} from 'shells/help/help-button';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

export function HelpDripSequences() {
    const {onOpen} = useOpenableModal(OpenableModals.DRIP_SEQUENCE_INFO_MODAL);

    const onClick = () => {
        onOpen();
    };

    // @ts-expect-error
    return <HelpButton onClick={onClick} />;
}
